module.exports = __webpack_public_path__ + "static/media/c15-connect.7a5d731f.png";